import { render } from "./HdFormFile.vue?vue&type=template&id=64ed9013"
import script from "./HdFormFile.vue?vue&type=script&lang=js"
export * from "./HdFormFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__